import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Landing from './pages/Landing/Landing';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import AddCourse from './pages/AddCourse/AddCourse';
import CoursePlayer from './pages/CoursePlayer/CoursePlayer';
import { Route, Routes, useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/Profile/Profile';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import CancellationRefundPolicy from './pages/Legal/Cancellationrefundpolicy';
import ShippingDeliveryPolicy from './pages/Legal/Shippingdeliverypolicy';
import CookiePolicy from './pages/Legal/CookiePolicy';
import Terms from './pages/Legal/Terms';
import RoadmapCreate from './pages/RoadmapCreate/RoadmapCreate';
import RoadmapView from './pages/RoadmapView/RoadmapView';
import RoadmapAddItem from './pages/RoadmapAddItem/RoadmapAddItem';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import { FocusTimerProvider } from './components/FocusTimer/FocusTimerProvider';
import FloatingTimerBubble from "./components/FocusTimer/FloatingTimerBubble";
import TimerPanel from "./components/FocusTimer/TimerPanel";
import ProjectPage from './pages/ProjectPage/ProjectPage';
import SkillPage from './pages/SkillPage/SkillPage';
import GuidePage from './pages/GuidePage/GuidePage';
import CertificatePage from './pages/CertificatePage/CertificatePage';
import CertificatePolicy from './pages/Legal/CertificatePolicy';
import MyCourses from './pages/MyCourses/MyCourses';
import AdminDashboard from './pages/Admin/AdminDashboard';
import Roadmaps from './pages/Roadmaps/Roadmaps';
import DashboardLayout from './layouts/DashboardLayout';
import TracksBrowse from './pages/Tracks/TracksBrowse';
import TrackDetail from './pages/Tracks/TrackDetail';
import TrackAssessment from './pages/Tracks/TrackAssessment';
import TrackResourcePlayer from './pages/Tracks/TrackResourcePlayer';
import TrackProjectView from './pages/Tracks/TrackProjectView';
import Upgrade from './pages/Upgrade/Upgrade';
import ProWelcome from './pages/Upgrade/ProWelcome';
import PublicProfile from './pages/Profile/PublicProfile';
import TracksPublic from './pages/Tracks/TracksPublic';
import { SidebarProvider } from './context/SidebarContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = "438492286828-b2qtp41m16852h5hogdr9ep0toe6ek3n.apps.googleusercontent.com";

const DASHBOARD_PREFIXES = [
  '/dashboard',
  '/tracks',
  '/add-course',
  '/my-courses',
  '/profile',
  '/roadmap',
  '/project',
  '/skill',
  '/certificate',
  '/upgrade',
  '/pro-welcome',
  '/admin',
];

function AppContent() {
  const location = useLocation();
  const isDashboard = DASHBOARD_PREFIXES.some(prefix =>
    location.pathname.startsWith(prefix)
  );

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/shipping-delivery-policy" element={<ShippingDeliveryPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/u/:username" element={<PublicProfile />} />
        <Route path="/certificate-policy" element={<CertificatePolicy />} />
        <Route path="/course/:id" element={<CoursePlayer />} />
        <Route path="/tracks/public" element={<TracksPublic />} />

        {/* ── Dashboard Layout Wrapper (Auth Required) ── */}
        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tracks" element={<TracksBrowse />} />
          <Route path="/tracks/:slug" element={<TrackDetail />} />
          <Route path="/tracks/:slug/assessment/:phaseId" element={<TrackAssessment />} />
          <Route path="/tracks/:slug/resource/:phaseId/:resourceIndex" element={<TrackResourcePlayer />} />
          <Route path="/tracks/:slug/project/:phaseId" element={<TrackProjectView />} />
          <Route path="/add-course" element={<AddCourse />} />
          <Route path="/my-courses" element={<MyCourses />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/roadmaps" element={<Roadmaps />} />
          <Route path="/roadmap/create" element={<RoadmapCreate />} />
          <Route path="/roadmap/:id" element={<RoadmapView />} />
          <Route path="/roadmap/add-item/:roadmapId" element={<RoadmapAddItem />} />
          <Route path="/project/:roadmapId" element={<ProjectPage />} />
          <Route path="/skill/:roadmapId" element={<SkillPage />} />
          <Route path="/certificate/:certificateId" element={<CertificatePage />} />
          <Route path="/upgrade" element={<Upgrade />} />
          <Route path="/pro-welcome" element={<ProWelcome />} />
          <Route path="/admin" element={<ProtectedRoute adminOnly={true}><AdminDashboard /></ProtectedRoute>} />
        </Route>

        <Route path="*" element={
          <div>
            <h1>404 - Page Not Found</h1>
            <p>The page you are looking for does not exist. Return to the <a href="/">homepage</a>.</p>
          </div>
        } />
      </Routes>

      {!isDashboard && <Footer />}

      <FloatingTimerBubble />
      <TimerPanel />
    </div>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <FocusTimerProvider>
        <SidebarProvider>
          <AppContent />
        </SidebarProvider>
      </FocusTimerProvider>
    </GoogleOAuthProvider>
  );
}

export default App;